import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const CheckoutPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "CheckoutPage" */ './Container'),
  'page'
);
